import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { LayoutFooterComponent } from 'src/core/components/shared/layout/footer/footer.component';
import { LayoutHeaderComponent } from 'src/core/components/shared/layout/header/header.component';
import { LayoutMainComponent } from 'src/core/components/shared/layout/main/main.component';
import {
  DialogService,
  DomService,
  LocalStorageService,
} from 'src/core/services';

@Component({
  selector: 'core-main',
  templateUrl: './main.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LayoutFooterComponent, LayoutHeaderComponent, LayoutMainComponent],
  providers: [provideTranslocoScope({ scope: 'core' })],
})
export class MainComponent implements OnInit {
  private domService = inject(DomService);
  private localStorageService = inject(LocalStorageService);
  private dialogService = inject(DialogService);
  private viewContainerRef = inject(ViewContainerRef);

  constructor() {
    this.dialogService.setViewContainerRef(this.viewContainerRef);
  }

  ngOnInit() {
    this.domService.setHtmlAttribute(
      'data-theme',
      this.localStorageService.getTheme()
        ? this.localStorageService.getTheme()
        : 'light',
    );
  }
}
